import {
  appraiserContactCard,
  attorneyContactCard,
  contactCard,
  homeWarrantyContactCard,
  leadSourceCard,
  lenderContactCard,
  notesCard,
  otherContactCard,
  propertyDetailsCard,
  titleOfficerContactCard,
} from '../shared';
import type { DefaultCoverSheetConfig, LocaleOverrides } from '../types';
import {
  buyerCard,
  buyersAgentCard,
  clientGroupCard,
  commissionDetailsCard,
  emdCard,
  importantDatesCard,
  propertyBeingSoldCard,
  salesPriceCard,
  sellerCard,
  sellersAgentCard,
} from './cards';

export const BaseOfferConfig = {
  version: '1',
  sections: {
    propertyInfo: {
      id: 'propertyInfo',
      header: 'Property Info',
      sidebarText: 'Property Info',
      cards: {
        propertyBeingSoldCard,
        importantDatesCard,
        salesPriceCard,
        commissionDetailsCard,
        emdCard,
        propertyDetailsCard,
        notesCard,
      },
    },
    buySideContacts: {
      id: 'buySideContacts',
      header: "Buyer's Contacts",
      sidebarText: 'Buyer Contacts',
      cards: {
        buyersAgentCard,
        buyerCard,
        clientGroupCard,
        leadSourceCard: {
          ...leadSourceCard,
          id: 'buyerSideContacts.leadSource',
        },
      },
    },
    sellerSideContacts: {
      id: 'sellerSideContacts',
      header: "Seller's Contacts",
      sidebarText: 'Seller Contacts',
      cards: {
        sellersAgentCard,
        sellerTCCard: contactCard(
          'sellerSideContacts.sellerTC',
          'counterpartyTransactionCoordinator',
        ),
        sellerCard,
      },
    },
    additionalContacts: {
      id: 'additionalContacts',
      header: 'Additional Contacts',
      sidebarText: 'Additional Contacts',
      cards: {
        titleOfficerContactCard,
        lenderContactCard,
        appraiserContactCard,
        attorneyContactCard,
        homeWarrantyContactCard,
        otherContactCard,
      },
    },
  },
} satisfies DefaultCoverSheetConfig;

export type OfferLocaleOverrides = LocaleOverrides<typeof BaseOfferConfig>;
